export const EducationList = [
    { duration: "From 2008-2014", school: "Pahy Primary School, Pailin Province" },
    { duration: "From 2014-2017", school: "Phnom Yat Secondary School, Pailin Province" },
    { duration: "From 2017-2020", school: "Hunsen Krong Tep Nimit Highschool, Pailin Province" },
    { duration: "From 2020-Now", school: "Techo Scholarship at Cambodia Academy of Digital Technology, Majoring in Computer Science" },
];